<template>
  <v-tooltip bottom :disabled="isTeacher">
    <template v-slot:activator="{ on }">
      <div v-on="on" class="d-inline-block">
        <v-btn
          :small="small"
          :depressed="depressed"
          width="100"
          :disabled="!isTeacher"
          class="white--text text-capitalize"
          :loading="loading"
          color="#29284c"
          @click="model = true"
        >
          Reset
        </v-btn>
        <v-dialog v-model="model" max-width="400">
          <v-card>
            <v-card-title class="headline">Reset Progress</v-card-title>
            <v-card-text>
              <p>
                Want to reset your student's job in this activity?
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small :loading="loading" class="text-capitalize" color="#29284c" text @click="model = false">
                Cancel
              </v-btn>
              <v-btn small :loading="loading" class="white--text text-capitalize" color="#29284c" @click="onReset">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    If you want to reset your progress, please contact your teacher.
  </v-tooltip>
</template>

<script>
import { resetStepProgress } from '@/api/api';

export default {
  props: {
    stepType: { type: String, required: true },
    /**
     * @type {"TEACH_LISTENING"|"TEACH_EXERCISE"|"TEACH_SPEAK"|"TEACH_HOMEWORK"|"PRACTICE_LISTENING"|"PRACTICE_TRANSCRIPT"|"PRACTICE_PRONUNCIATION"|"PRACTICE_SPEAK"|"PRACTICE_HOMEWORK"|"GRAMMAR_EXERCISE"}
     */
    stepUuid: { type: String, required: true },
    small: {
      type: Boolean,
      default: true,
    },
    depressed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      model: false,
    };
  },
  computed: {
    isTeacher() {
      return this.$store.getters.profile.role === 'TEACHER';
    },
  },
  methods: {
    async onReset() {
      this.loading = true;
      try {
        await resetStepProgress(this.stepUuid, this.stepType);
        this.$emit('reset');
        this.model = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
